module.exports = __webpack_public_path__ + "static/mindfulness-14c4e27db9a58b48d574bf926947ae22.svg";